import { queryOptions, useQuery } from '@tanstack/react-query';
import { buildAlertsSearchRequest, getSurveillanceAlerts, mapAlertsResponse, type SurveillanceAlertFilters } from '@/services/api/market-surveillance';

export const SURVEILLANCE_QUERY_KEY = ['market-surveillance'] as const;
export const SURVEILLANCE_ALERTS_QUERY_KEY = [...SURVEILLANCE_QUERY_KEY, 'alerts'] as const;
// Separate list/alert prefixes so status changes can invalidate lists without refetching every open detail subtree (and vice versa)
export const SURVEILLANCE_ALERT_LISTS_QUERY_KEY = [...SURVEILLANCE_ALERTS_QUERY_KEY, 'list'] as const;
export const SURVEILLANCE_ALERT_QUERY_KEY = [...SURVEILLANCE_ALERTS_QUERY_KEY, 'alert'] as const;

export const surveillanceAlertsQueryOptions = (filters: SurveillanceAlertFilters, cursor?: string) => {
  const request = buildAlertsSearchRequest(filters, cursor);
  return queryOptions({
    queryKey: [...SURVEILLANCE_ALERT_LISTS_QUERY_KEY, request],
    queryFn: ({ signal }) => getSurveillanceAlerts(request, signal),
    select: mapAlertsResponse,
  });
};

export const useSurveillanceAlerts = (filters: SurveillanceAlertFilters, cursor?: string) => useQuery(surveillanceAlertsQueryOptions(filters, cursor));
